// Calendario editoriale del LANCIO reale di Lempole.
// Data: 08.08.2026 → oggi.
//
// Struttura in 3 fasi:
//   Fase 1 · TEASER (10 → 14 agosto)   — 1 post/giorno, curiosità sul bradipo
//   Fase 2 · REVEAL (15 → 24 agosto)   — 1 post/giorno, presentazione del progetto,
//                                        manifesto, brand, etichetta
//   Fase 3 · LIVE   (25 ago → ottobre) — 2-4 post/settimana, vendemmia in diretta,
//                                        cantina, foliage. Frequenza maggiore
//                                        durante la vendemmia (metà settembre).

const PHOTO = {
  hero:        'https://customer-assets-eiarnc6j.emergentagent.net/job_lempole-design/artifacts/3aysd8m4_Hero%20image%20-%20desktop.png',
  bottle:      'https://customer-assets-eiarnc6j.emergentagent.net/job_lempole-design/artifacts/r7148kd2_Generated%20with%20Kive.ai%20-%20kive-image%20%2815%29.webp',
  terraces:    'https://customer-assets-eiarnc6j.emergentagent.net/job_lempole-design/artifacts/bmap93ez_IMG_6323.webp',
  breathe:     'https://customer-assets-eiarnc6j.emergentagent.net/job_lempole-design/artifacts/6vxqu2fr_Generated%20with%20Kive.ai%20-%20kive-image%20%2814%29.webp',
  vigneron:    process.env.PUBLIC_URL + '/images/vigneron-retouched.webp',
  grapes:      process.env.PUBLIC_URL + '/venues/grapes-vine.jpg',
  basket:      process.env.PUBLIC_URL + '/venues/basket.jpg',
  bottlesIris: process.env.PUBLIC_URL + '/venues/bottles-iris.jpg',
  kidsHarvest: process.env.PUBLIC_URL + '/venues/kids-harvest.jpg',
  slothLogo:   'https://customer-assets-eiarnc6j.emergentagent.net/job_lempole-design/artifacts/em9l4iqr_lempole-sloth.png',
};

export const PILLAR_COLORS = {
  manifesto: '#a44a30',
  terroir:   '#7a3520',
  vigneron:  '#7f8a72',
  prodotto:  '#4a4038',
};
export const PILLAR_LABEL = {
  manifesto: 'Manifesto',
  terroir:   'Terroir',
  vigneron:  'Vigneron',
  prodotto:  'Prodotto',
};

export const WEEKLY_STORIES = [
  { day: 'Lunedì',   slot: 'mattina',    label: 'Lunedì lento',      idea: 'Una foto del vigneto appena alzato. Nessun testo, un\u2019emoji o una frase in Caveat.' },
  { day: 'Mercoledì', slot: 'pomeriggio', label: 'Mercoledì diario',  idea: 'Estratto di 2 righe da un articolo del diario + sticker link a lempole.com/diario.' },
  { day: 'Venerdì',   slot: 'sera',       label: 'Venerdì tramonto',  idea: 'Golden hour sui terrazzamenti + slider di temperatura per raccontare l\u2019escursione termica.' },
];

// Utility to keep the post objects short
const p = (day, dayName, slot, pillar, kind, media, title, hook, phase) => ({
  day, dayName, slot, pillar, kind, media, title, hook, phase,
});

export const CALENDAR_MONTHS = [
  {
    id: 'ago',
    name: 'Agosto 2026',
    subtitle: 'Il teaser, la rivelazione',
    intro: 'Prima settimana: 5 teaser al giorno per accendere la curiosità intorno al bradipo. Dal 15 in poi: la vera presentazione del progetto — le due anime, il manifesto, la prima etichetta. Fine mese: si passa al diario in diretta.',
    posts: [
      // — FASE 1 · TEASER (10-14 agosto) — 1 post/giorno —
      p('2026-08-10', 'Lun', 'mattina', 'manifesto', 'sketch', { slug: 'perche-un-bradipo' },
        'Cosa ci fa un bradipo a Lamole?',
        'Non chiediamo risposte. Solo il permesso di raccontarla piano.', 'teaser'),
      p('2026-08-11', 'Mar', 'sera', 'manifesto', 'quote',
        { text: '“Alcune cose\u2028si muovono\u2028controcorrente.”', by: '— sussurro' },
        'Qualcosa si muove',
        'Domani un altro indizio. Non abbiate fretta.', 'teaser'),
      p('2026-08-12', 'Mer', 'pomeriggio', 'terroir', 'photo', { src: PHOTO.terraces },
        '600 metri di quota',
        'Il posto giusto per fare le cose piano. Ancora non vi diciamo cos\u2019è.', 'teaser'),
      p('2026-08-13', 'Gio', 'sera', 'manifesto', 'quote',
        { text: '“Poche bottiglie.\u2028Molta anima.\u2028Nessuna fretta.”', by: '— manifesto in tre righe' },
        'Il triplo respiro',
        'Manca poco. Domani un\u2019altra riga.', 'teaser'),
      p('2026-08-14', 'Ven', 'mattina', 'manifesto', 'sketch', { slug: 'perche-un-bradipo' },
        'Buongiorno, Lempole',
        'Ci presentiamo. Il resto lo raccontiamo con calma dai prossimi giorni.', 'teaser'),

      // — FASE 2 · REVEAL (15-24 agosto) — 1 post/giorno —
      p('2026-08-15', 'Sab', 'pomeriggio', 'manifesto', 'quote',
        { text: '“Lempole.\u2028Slow Wine\u2028Philosophy.”', by: '— chi siamo' },
        'Il primo giorno vero',
        'Ferragosto per noi vuol dire cominciare. Il resto del Paese si ferma, noi apriamo.', 'reveal'),
      p('2026-08-16', 'Dom', 'sera', 'vigneron', 'photo', { src: PHOTO.vigneron },
        'Chi c\u2019è dietro Lempole',
        'Vent\u2019anni di vendemmie per il mondo, poi la scelta di tornare a Lamole. Lui è Raffaello Tiezzi.', 'reveal'),
      p('2026-08-17', 'Lun', 'mattina', 'terroir', 'sketch', { slug: 'lamole-cru-silenzioso-chianti-classico' },
        'Perché Lamole',
        'Un piccolo cru silenzioso del Chianti Classico. Lo racconta la nostra prima carta.', 'reveal'),
      p('2026-08-18', 'Mar', 'pomeriggio', 'terroir', 'photo', { src: PHOTO.terraces },
        'I terrazzamenti del Madonnino',
        'Terrazzamenti abbandonati da 60 anni. Li stiamo rimettendo in piedi, un muretto alla volta.', 'reveal'),
      p('2026-08-19', 'Mer', 'sera', 'manifesto', 'sketch', { slug: 'perche-un-bradipo' },
        'Perché un bradipo',
        'Non è un logo carino. È un manifesto. Storia completa nel diario.', 'reveal'),
      p('2026-08-20', 'Gio', 'pomeriggio', 'manifesto', 'photo', { src: PHOTO.breathe },
        'Le due anime',
        'La radice che custodisce. Il frutto che si racconta. È il nostro punto di vista.', 'reveal'),
      p('2026-08-21', 'Ven', 'mattina', 'prodotto', 'photo', { src: PHOTO.bottle },
        'La prima etichetta',
        'Ecco Lempole Rosato IGT Toscana. Un Sangiovese di Lamole che ha scelto di essere delicato.', 'reveal'),
      p('2026-08-22', 'Sab', 'pomeriggio', 'prodotto', 'sketch', { slug: 'sangiovese-rosato-contro-corrente' },
        'Perché un rosato',
        'In Chianti è una scelta radicale. Vi spieghiamo perché siamo partiti da qui.', 'reveal'),
      p('2026-08-23', 'Dom', 'sera', 'prodotto', 'sketch', { slug: 'solo-acciaio-perche-no-legno' },
        'Solo acciaio',
        'Nessun legno, nessuna maschera. La trasparenza è la nostra disciplina.', 'reveal'),
      p('2026-08-24', 'Lun', 'mattina', 'prodotto', 'quote',
        { text: '“1.000 bottiglie.\u2028Ci fermeremo qui.”', by: '— edizione unica' },
        'L\u2019edizione limitata',
        'Non è marketing: è la fotografia della verità. Un ettaro, resa bassa, vinificazione lenta.', 'reveal'),

      // — FASE 3 · LIVE (25 ago → 31 ago) — inizia il diario —
      p('2026-08-25', 'Mar', 'mattina', 'vigneron', 'photo', { src: PHOTO.grapes },
        'Buongiorno dalla vigna',
        'Da oggi il profilo diventa un diario. Ogni giorno vi portiamo un pezzo di Lamole.', 'live'),
      p('2026-08-27', 'Gio', 'sera', 'terroir', 'sketch', { slug: 'escursione-termica-lamole' },
        'Le notti fresche di agosto',
        'A 600 metri, di notte, si dorme sotto le coperte. È il segreto del nostro Sangiovese.', 'live'),
      p('2026-08-29', 'Sab', 'pomeriggio', 'terroir', 'photo', { src: PHOTO.grapes },
        'L\u2019invaiatura è iniziata',
        'I primi acini stanno virando. Da adesso ogni giorno cambia colore un po\u2019 di più.', 'live'),
      p('2026-08-31', 'Lun', 'mattina', 'prodotto', 'sketch', { slug: 'solo-acciaio-perche-no-legno' },
        'Cantina in ordine',
        'Vasche pulite, tubi controllati. Aspettiamo settembre con pazienza operativa.', 'live'),
    ],
  },
  {
    id: 'set',
    name: 'Settembre 2026',
    subtitle: 'La vendemmia in diretta',
    intro: 'Il mese chiave. La settimana della vendemmia viene raccontata giorno per giorno, con storie e post ad alta frequenza. Il resto del mese: cantina, primi mosti, decantazione.',
    posts: [
      p('2026-09-02', 'Mer', 'sera', 'terroir', 'sketch', { slug: 'un-anno-in-vigna-mese-per-mese' },
        'Contatore attivo',
        'Manca una settimana all\u2019inizio della vendemmia. Da domani, aggiornamenti quotidiani dal vigneto.', 'live'),
      p('2026-09-04', 'Ven', 'mattina', 'vigneron', 'photo', { src: PHOTO.basket },
        'Cassette pronte',
        'Ne servono 40 per ettaro. Da 15 kg, mai più. Le uve devono arrivare intatte.', 'live'),
      // Vendemmia — 5 giorni consecutivi, alta frequenza
      p('2026-09-07', 'Lun', 'mattina', 'vigneron', 'photo', { src: PHOTO.grapes },
        'Giorno 1 · Il primo grappolo',
        'Sei di mattina. Il primo grappolo. Succo dolce, buccia soda. Si comincia.', 'live'),
      p('2026-09-08', 'Mar', 'sera', 'terroir', 'sketch', { slug: 'viticoltura-eroica-terrazzamenti' },
        'Giorno 2 · Solo a mano',
        'Il trattore qui non passa. Passiamo noi, con la cesta in spalla, un filare alla volta.', 'live'),
      p('2026-09-09', 'Mer', 'sera', 'prodotto', 'photo', { src: PHOTO.breathe },
        'Giorno 3 · In cantina',
        'Le prime uve arrivate. Diraspatura, pressatura soffice, decantazione a freddo. Piano.', 'live'),
      p('2026-09-10', 'Gio', 'pomeriggio', 'vigneron', 'photo', { src: PHOTO.kidsHarvest },
        'Giorno 4 · La famiglia',
        'Amici che tornano ogni anno. Bambini che portano le cassette. La vendemmia è ancora un rito.', 'live'),
      p('2026-09-11', 'Ven', 'sera', 'vigneron', 'photo', { src: PHOTO.terraces },
        'Giorno 5 · L\u2019ultima cassetta',
        'Ultimo giro tra i filari. La vigna torna in silenzio. Da adesso, solo cantina.', 'live'),
      p('2026-09-13', 'Dom', 'mattina', 'prodotto', 'sketch', { slug: 'sangiovese-rosato-contro-corrente' },
        'Il mosto ha voce da bambino',
        'Assaggio a freddo. Fragolina, sapidità, agrume. Se ne parlerà a dicembre.', 'live'),
      p('2026-09-16', 'Mer', 'sera', 'prodotto', 'sketch', { slug: 'solo-acciaio-perche-no-legno' },
        'Fermentazione partita',
        'Lieviti indigeni al comando. Nei prossimi giorni la cantina profumerà di frutta.', 'live'),
      p('2026-09-19', 'Sab', 'pomeriggio', 'terroir', 'photo', { src: PHOTO.terraces },
        'Vigna in riposo',
        'Le viti tornano a rilassarsi. Fine mese cominciamo la potatura verde autunnale.', 'live'),
      p('2026-09-22', 'Mar', 'sera', 'manifesto', 'quote',
        { text: '“Regalo\u2028momenti di\u2028meritata lentezza.”', by: '— Raffaello Tiezzi' },
        'Bilancio a metà',
        'Dopo undici giorni intensi, un momento di calma. È tutto quello per cui lavoriamo.', 'live'),
      p('2026-09-26', 'Sab', 'mattina', 'vigneron', 'photo', { src: PHOTO.vigneron },
        'Prima ispezione post-vendemmia',
        'Le vigne oggi sono più tranquille di me. Guarderemo la salute delle foglie fino a metà ottobre.', 'live'),
      p('2026-09-29', 'Mar', 'pomeriggio', 'terroir', 'sketch', { slug: 'biodiversita-in-vigna' },
        'Torna il bosco',
        'Con l\u2019autunno la biodiversità intorno alle vigne cambia. Anche gli animali del bosco tornano vicini.', 'live'),
    ],
  },
  {
    id: 'ott',
    name: 'Ottobre 2026',
    subtitle: 'Il fermento, l\u2019attesa',
    intro: 'Il vino inizia a diventare vino. Post di cantina, primi assaggi, foliage sui terrazzamenti. Chiudiamo il trimestre preparando l\u2019uscita di dicembre.',
    posts: [
      p('2026-10-02', 'Ven', 'sera', 'prodotto', 'sketch', { slug: 'calice-giusto-arte-incontro' },
        'Verso il calice giusto',
        'Il vino sta stabilizzando. Nel frattempo, un consiglio per quando lo avrete in mano.', 'live'),
      p('2026-10-05', 'Lun', 'pomeriggio', 'terroir', 'photo', { src: PHOTO.terraces },
        'Foliage sui terrazzamenti',
        'Le foglie della vite virano al giallo caldo. Lamole cambia veste in una settimana.', 'live'),
      p('2026-10-08', 'Gio', 'sera', 'vigneron', 'photo', { src: PHOTO.breathe },
        'Primo assaggio significativo',
        'Il mosto in fermentazione comincia a dare risposte. Sapidità, freschezza, e una nota di iris.', 'live'),
      p('2026-10-11', 'Dom', 'mattina', 'manifesto', 'sketch', { slug: 'cos-e-slow-wine' },
        'Anche in cantina, slow',
        'La cantina non riposa, ma non accelera. Slow anche qui — soprattutto qui.', 'live'),
      p('2026-10-15', 'Gio', 'pomeriggio', 'terroir', 'sketch', { slug: 'muretti-a-secco-paesaggio' },
        'Muretti d\u2019autunno',
        'Con l\u2019inverno alle porte, rialziamo i tratti crollati. Poche pietre alla volta.', 'live'),
      p('2026-10-18', 'Dom', 'sera', 'manifesto', 'quote',
        { text: '“Ottobre\u2028è il mese\u2028che matura tutto.”', by: '— nota di cantina' },
        'Bilancio d\u2019annata',
        'Ottobre matura il vino, ma anche noi. Prime decisioni sui mesi di elevazione.', 'live'),
      p('2026-10-22', 'Gio', 'sera', 'prodotto', 'photo', { src: PHOTO.bottle },
        'Cominciamo a pensare all\u2019uscita',
        'Mancano due mesi. Il rosato sta trovando la sua voce. Le prime prenotazioni sono aperte.', 'live'),
      p('2026-10-26', 'Lun', 'mattina', 'vigneron', 'photo', { src: PHOTO.bottlesIris },
        'Ricordi di primavera',
        'Un ritratto tra iris ormai appassiti. In sei mesi Lamole ha già raccontato mille cose.', 'live'),
      p('2026-10-30', 'Ven', 'sera', 'prodotto', 'quote',
        { text: '“Dicembre\u2028esce Lempole.”', by: '— promemoria' },
        'Preparate il calendario',
        '1.000 bottiglie non aspettano. Il DM è aperto per chi vuole prenotare una copia numerata.', 'live'),
    ],
  },
];

export const CAL_STATS = CALENDAR_MONTHS.map((m) => ({
  id: m.id,
  posts: m.posts.length,
  stories: 12,
}));

// Extra metadata for the timeline legend
export const PHASES = {
  teaser: { label: 'Teaser',  color: '#c88968', dates: '10 → 14 agosto', frequency: '1/giorno' },
  reveal: { label: 'Reveal',  color: '#a44a30', dates: '15 → 24 agosto', frequency: '1/giorno' },
  live:   { label: 'Live',    color: '#7f8a72', dates: '25 ago → ottobre', frequency: '2-4/settimana, +giornaliera in vendemmia' },
};
